import {
  BillingAccount,
  FuneralHome,
  ImportCandidate,
  ImportResult,
  Notification,
  ProductLink,
} from "../types/domain";

function tukiosProductLinks(obituaryUrl: string): ProductLink[] {
  return [
    {
      type: "flowers",
      label: "Send Flowers",
      subtitle: "Order flowers for the family",
      url: `${obituaryUrl}/flowers`,
    },
    {
      type: "cards",
      label: "Send a Card",
      subtitle: "Show your sympathy to the family",
      url: `${obituaryUrl}/cards`,
    },
    {
      type: "gifts",
      label: "Plant Trees",
      subtitle: "In remembrance",
      url: `${obituaryUrl}/gifts`,
    },
  ];
}

export const monarchFuneralHome: FuneralHome = {
  id: "fh-monarch",
  name: "Monarch Funeral Home & Cremation Services",
  websiteUrl: "https://www.monarchfuneralhome.com",
  ownerName: "Bill",
  email: "bill@monarchfuneralhome.com",
  phone: "(954) 972-7565",
  address: "2950 N State Rd 7, Margate, FL 33063",
  providerLabel: "Tukios + Batesville",
  providerConfidence: "high",
  status: "active",
  createdAt: "2026-03-27T14:00:00.000Z",
};

export const monarchImportCandidates: ImportCandidate[] = [
  {
    decedentName: "Dr. Jennifer Laura Miano",
    dob: "1979-05-31",
    dod: "2026-03-23",
    obituaryUrl: "https://www.monarchfuneralhome.com/obituary/jennifer-miano",
    photoUrl: "https://www.monarchfuneralhome.com/fh_live/16500/16565/images/obituaries/9578583_fbse.png",
    confidence: "high",
    productLinks: tukiosProductLinks("https://www.monarchfuneralhome.com/obituary/jennifer-miano"),
    services: [
      {
        title: "Visitation",
        type: "visitation",
        date: "2026-03-28",
        time: "15:00",
        endTime: "17:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
    ],
  },
  {
    decedentName: "Giacomo 'Jimmy' Billisi",
    dob: "1937-10-28",
    dod: "2026-03-21",
    obituaryUrl: "https://www.monarchfuneralhome.com/obituary/jimmy-billisi",
    photoUrl: "https://www.monarchfuneralhome.com/fh_live/16500/16565/images/obituaries/9577025_fbse.jpeg",
    confidence: "high",
    productLinks: tukiosProductLinks("https://www.monarchfuneralhome.com/obituary/jimmy-billisi"),
    services: [
      {
        title: "Visitation",
        type: "visitation",
        date: "2026-03-24",
        time: "16:00",
        endTime: "20:00",
        venue: "Monarch Funeral Home",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
      {
        title: "Prayer Service",
        type: "memorial_service",
        date: "2026-03-24",
        time: "18:30",
        venue: "Monarch Funeral Home",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
      {
        title: "Funeral Mass",
        type: "funeral",
        date: "2026-03-25",
        time: "11:00",
        venue: "St. Elizabeth Ann Seton Catholic Church",
        address: "1401 Coral Ridge Drive, Coral Springs, FL 33071",
        livestreamUrl: "https://www.hdezwebcast.com/show/jimmy-billisi",
      },
      {
        title: "Cryptside Service",
        type: "graveside",
        date: "2026-03-25",
        time: "13:00",
        venue: "Our Lady Queen of Heaven Cemetery",
        address: "1500 S. State Road 7, North Lauderdale, FL 33068",
      },
    ],
  },
  {
    decedentName: "Shane Daniel Douglas",
    dob: "1999-07-21",
    dod: "2026-03-18",
    obituaryUrl: "https://www.monarchfuneralhome.com/obituary/shane-douglas",
    photoUrl: "https://www.monarchfuneralhome.com/fh_live/16500/16565/images/obituaries/9575947_fbse.png",
    confidence: "high",
    productLinks: tukiosProductLinks("https://www.monarchfuneralhome.com/obituary/shane-douglas"),
    services: [
      {
        title: "Visitation",
        type: "visitation",
        date: "2026-03-29",
        time: "16:00",
        endTime: "18:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
      {
        title: "Funeral Service",
        type: "funeral",
        date: "2026-03-29",
        time: "18:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
        livestreamUrl: "https://www.hdezwebcast.com/show/shane-douglas",
      },
    ],
  },
  {
    decedentName: "Basiliki 'Baso' Newball",
    dob: "1943-12-20",
    dod: "2026-03-17",
    obituaryUrl: "https://www.monarchfuneralhome.com/obituary/baso-newball",
    photoUrl: "https://www.monarchfuneralhome.com/fh_live/16500/16565/images/obituaries/9576051_fbse.jpeg",
    confidence: "high",
    productLinks: tukiosProductLinks("https://www.monarchfuneralhome.com/obituary/baso-newball"),
    services: [
      {
        title: "Visitation",
        type: "visitation",
        date: "2026-03-22",
        time: "13:00",
        endTime: "14:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
      {
        title: "Memorial Service",
        type: "memorial_service",
        date: "2026-03-22",
        time: "14:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
        livestreamUrl: "https://www.hdezwebcast.com/show/baso-newball",
      },
      {
        title: "Reception",
        type: "reception",
        date: "2026-03-22",
        time: "15:00",
        endTime: "17:00",
        venue: "Monarch Funeral Home & Cremation Services",
        address: "2950 N State Rd 7, Margate, FL 33063",
      },
    ],
  },
];

export const monarchImportResult: ImportResult = {
  provider: "Tukios + Batesville",
  providerConfidence: "high",
  memorialsFound: monarchImportCandidates.length,
  eventsFound: monarchImportCandidates.reduce(
    (sum, c) => sum + c.services.length,
    0,
  ),
  candidates: monarchImportCandidates,
  importedAt: "2026-03-27T14:02:00.000Z",
};

const monarchMemorialIds = [
  "mem-jennifer-miano",
  "mem-jimmy-billisi",
  "mem-shane-douglas",
  "mem-baso-newball",
];

export function createMonarchNotifications(): Notification[] {
  return monarchImportCandidates.map((candidate, i) => ({
    id: `notif-import-${i}`,
    funeralHomeId: "fh-monarch",
    type: "service_ready" as const,
    title: `Event Kit for ${candidate.decedentName} is Ready`,
    body: `We created the event page, RSVP link, and check-in tools for ${candidate.decedentName}. Tap to view the event kit.`,
    read: false,
    memorialId: monarchMemorialIds[i],
    createdAt: new Date(
      new Date("2026-03-27T14:02:00.000Z").getTime() + i * 15000,
    ).toISOString(),
  }));
}

export const monarchBilling: BillingAccount = {
  id: "billing-monarch",
  funeralHomeId: "fh-monarch",
  plan: "professional",
  status: "trial",
  trialEndsAt: "2026-04-27T00:00:00.000Z",
};
